<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Privacy"
    :submit="submit"
    :status="status"
    :breadcrumbs="[
        {
          text: 'Configuración y politicas',
          disabled: false,
          href: '/admin/privacy'
        },
        {
          text: '...',
          disabled: false,
          href: '#'
        },
        {
          text: $route.params.id ? 'Editar' : 'Crear',
          disabled: true,
          href: '#'
        }
      ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col>
              <ValidationProvider
                ref="description"
                rules="required"
                v-slot="{ errors }"
              >
              <div class="label-base">Descripción</div>
                <v-textarea
                  :error-messages="errors"
                  v-model="data.description"
                  solo
                    placeholder="Descripción"
                    hide-details="auto"
                    class="text-tarea-base legal-text-area-scroll pb-1"
                  :rows="dynamicRows"
                />
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm},
    mounted() {
      this.calculateRows();
      window.addEventListener("resize", this.calculateRows);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.calculateRows);
    },
    computed: {
      ...mapState({
        status: state => state.Privacy.status,
      })
    },
    data() {
      return {
        storeName: 'Privacy',
        title: "Politica de Privacidad",
        data: {
          title: "",
          description: '',
        },
        dynamicRows: 6,
      }
    },
    methods: {
      calculateRows() {
        const viewportHeight = window.innerHeight;

        const rowHeight = 24;
        const usedHeight = viewportHeight * 0.4;

        const rows = Math.max(3, Math.min(Math.floor(usedHeight / rowHeight), 40));

        this.dynamicRows = rows;
      },
    },
  }
</script>
